var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowing)?_c('div',{ref:"interactElement",staticClass:"card",class:{
    isAnimating: _vm.isInteractAnimating,
    isCurrent: _vm.isCurrent
  },style:({ transform: _vm.transformString })},[_c('img',{staticClass:"card-image",attrs:{"src":_vm.imageSrc,"alt":_vm.card.imageAlt}}),_c('div',{ref:"cardTitleContainer",staticClass:"card-text-container"},[_c('h1',{ref:"cardTitle",staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.card.question)+" ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }